import { getFlowCode } from './Utils/GeneralUtills';
import {
  getConfigXMLName,
  link_out,
  ListOfBanksName,
  ListOfEngine,
  ListOfFrameWork,
  paykey_engine,
  rebit_engine,
} from '../utils/DictionaryManagementUtils';
import { kbdTheme } from './Utils/Theme';
import { kbdAuthSteps, kbdErrorSteps, kbdStepMenu } from './Steps/MainSteps';
import kbdMainScreens from './Screens/ScreensMain';

export default function extractKeyboardJSON(configurations) {
  return {
    settings: kbdSettings(configurations),
    theme: kbdTheme(configurations),
    screens: kbdMainScreens(configurations),
    authSteps: kbdAuthSteps(),
    errorSteps: kbdErrorSteps(),
    steps: kbdStepMenu(configurations),
    flowConfigurations: kbdFlowConfigurations(configurations),
    flowNames: kbdFlowNames(configurations),
  };
}

const kbdSettings = ({ launch, deliverables }) => ({
  showIntro: launch.keyboard.access_to_bank_info_message,
  openInFullMode: deliverables.deliverables.redirect_from_keyboard_enabled,
});

const kbdFlowConfigurations = ({ services }) => services.screens_ordering
  .filter((serviceKey) => services[serviceKey].selected && (services[serviceKey].sub_category !== link_out))
  .map((serviceKey) => (getConfigXMLName(serviceKey)));

const kbdFlowNames = ({ services }) => services.screens_ordering
  .filter((serviceKey) => services[serviceKey].selected)
  .map((serviceKey) => ({
    flowCode: getFlowCode(services[serviceKey]),
    name: services[serviceKey].name,
  }));

const getListOfBuildSettings = (isAndroid, promotion, typedWords) => (isAndroid
  ? getAndroidListOfBuildSettings(promotion) : getIOSListOfBuildSettings(promotion, typedWords));

const getAndroidListOfBuildSettings = (promotions = false) => {
  const frameworkList = [
    ListOfFrameWork.gif,
    ListOfFrameWork.location,
    ListOfFrameWork.stickers,
    ListOfFrameWork.translation,
    ListOfFrameWork.clipboard,
    ListOfFrameWork.pengine,
    ListOfFrameWork.analytics,
    ListOfFrameWork.typingkpi,
    ListOfFrameWork.otp,
  ];
  if (promotions) {
    frameworkList.push(ListOfFrameWork.promotions);
  }
  return frameworkList;
};

const getIOSListOfBuildSettings = (promotion = false, typedWords = false) => {
  const frameworkList = [
    ListOfFrameWork.clipboard,
    ListOfFrameWork.analytics,
    ListOfFrameWork.kpi,
    ListOfFrameWork.translator,
    ListOfFrameWork.tooltips,
    ListOfFrameWork.themes,
    ListOfFrameWork.gif,
    ListOfFrameWork.sticker,
  ];
  if (promotion) {
    frameworkList.push(ListOfFrameWork.promotion);
  }
  if (typedWords) {
    frameworkList.push(ListOfFrameWork.typedWords);
  }
  return frameworkList;
};

export const extractBuildSettings = ({ keyboard, general, deliverables }, isAndroid) => ({
  kb_features: kbdFeaturesForBuildSettings(general.bank_name, keyboard, isAndroid),
  company: general.bank_name,
  engine: engineForBuildSettings(keyboard),
  OTA: keyboard.keyboard_language.is_OTA_dictionary_installed,
  iMessage: deliverables.deliverables.iMsg_enabled,
  wt_version: require('../../app.json').expo.version,
  default_language: keyboard.keyboard_language.is_rebit_engine
    ? keyboard.keyboard_language.default_languages[rebit_engine]
    : keyboard.keyboard_language.default_languages[paykey_engine],
  languages: languagesForBuildSettings(keyboard),
});

const kbdFeaturesForBuildSettings = (company, keyboard, isAndroid) => {
  switch (company) {
    case ListOfBanksName.demoApp:
      return getListOfBuildSettings(isAndroid, keyboard.promotion.enable_promotion, true);

    default:
      return getListOfBuildSettings(isAndroid);
  }
};

const engineForBuildSettings = ({ keyboard_language }) => (keyboard_language.is_rebit_engine
  ? ListOfEngine.rebit : ListOfEngine.paykey);

const languagesForBuildSettings = ({ keyboard_language }) => {
  const dictionary_language = {};
  const nlp_type = keyboard_language.is_rebit_engine ? rebit_engine : paykey_engine;
  Object.keys(keyboard_language.available_languages[nlp_type])
    .filter((languageItem) => keyboard_language.available_languages[nlp_type][languageItem].available)
    .forEach((language) => {
      dictionary_language[language] = keyboard_language.available_languages[nlp_type][language].enabled_upon_keyboard_launch;
    });
  return dictionary_language;
};
